import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ConsentDto, ConsentStatusDto, ConsentType } from './consents.model';

@Injectable({
  providedIn: 'root',
})
export class ConsentService {
  private readonly _httpClient = inject(HttpClient);

  private readonly baseUrl = `${environment.apiUrl}/api/public/Consents`;

  getConsents(): Observable<ConsentDto[]> {
    return this._httpClient.get<ConsentDto[]>(this.baseUrl);
  }

  getStatus(): Observable<ConsentStatusDto> {
    return this._httpClient.get<ConsentStatusDto>(`${this.baseUrl}/status`);
  }

  record(decisions: Partial<Record<ConsentType, boolean>>): Observable<void> {
    return this._httpClient.post<void>(this.baseUrl, { decisions });
  }

  revoke(consentType: ConsentType): Observable<void> {
    return this._httpClient.post<void>(`${this.baseUrl}/revoke`, {
      consentType,
    });
  }

  unsubscribeNewsletter(token: string): Observable<string> {
    return this._httpClient.post<string>(
      `${this.baseUrl}/unsubscribe-newsletter?token=${token}`,
      {},
    );
  }
}
